import React, { FunctionComponent } from 'react';
import { Body } from 'js/design_system/Body';
import styled from 'astroturf/react';
import _RequiredFields from "RequiredFieldsLabel-RequiredFields.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/design_system/forms/RequiredFieldsLabel.tsx?styleId=RequiredFields";


const RequiredFields = /*#__PURE__*/styled(Body, null, {
  displayName: "RequiredFields",
  styles: _RequiredFields
});

export const RequiredFieldsLabel: FunctionComponent = (props) => {
  return (
    <RequiredFields as="div" {...props}>
      * Required fields
    </RequiredFields>
  );
};
